import { FOOTER_TEXT } from '../../constants';
import { UpButton } from './up-button';

export const FooterTerms = () => {
  return (
    <>
      <UpButton />

      <hr className="mb-4 w-full h-0.5 rounded-md border-0 bg-white opacity-20" />

      <small
        className="text-text-light text-xs leading-5 block"
        dangerouslySetInnerHTML={{
          __html: FOOTER_TEXT,
        }}
      />
    </>
  );
};
